var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    fill: "#F3F3F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    stroke: "#E2E2E5",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.14 7.04688C13.3499 7.04693 13.5544 7.11302 13.7247 7.23578C13.8949 7.35854 14.0222 7.53175 14.0885 7.73088L14.36 8.54688H16C16.1326 8.54688 16.2598 8.59955 16.3536 8.69332C16.4473 8.78709 16.5 8.91427 16.5 9.04688C16.5 9.17948 16.4473 9.30666 16.3536 9.40043C16.2598 9.4942 16.1326 9.54688 16 9.54688L15.9985 9.58238L15.565 15.6539C15.5379 16.0322 15.3686 16.3862 15.091 16.6447C14.8134 16.9031 14.4483 17.0468 14.069 17.0469H9.931C9.55173 17.0468 9.18655 16.9031 8.90898 16.6447C8.63141 16.3862 8.46205 16.0322 8.435 15.6539L8.0015 9.58188L8 9.54688C7.86739 9.54688 7.74021 9.4942 7.64645 9.40043C7.55268 9.30666 7.5 9.17948 7.5 9.04688C7.5 8.91427 7.55268 8.78709 7.64645 8.69332C7.74021 8.59955 7.86739 8.54688 8 8.54688H9.64L9.9115 7.73088C9.97785 7.53167 10.1052 7.3584 10.2755 7.23563C10.4459 7.11286 10.6505 7.04682 10.8605 7.04688H13.14ZM10.5 11.0469C10.3775 11.0469 10.2593 11.0919 10.1678 11.1732C10.0763 11.2546 10.0178 11.3667 10.0035 11.4884L10 11.5469V14.5469C10.0001 14.6743 10.0489 14.7969 10.1364 14.8896C10.2239 14.9822 10.3435 15.038 10.4707 15.0455C10.5979 15.0529 10.7232 15.0115 10.8209 14.9297C10.9186 14.8479 10.9814 14.7319 10.9965 14.6054L11 14.5469V11.5469C11 11.4143 10.9473 11.2871 10.8536 11.1933C10.7598 11.0996 10.6326 11.0469 10.5 11.0469ZM13.5 11.0469C13.3674 11.0469 13.2402 11.0996 13.1464 11.1933C13.0527 11.2871 13 11.4143 13 11.5469V14.5469C13 14.6795 13.0527 14.8067 13.1464 14.9004C13.2402 14.9942 13.3674 15.0469 13.5 15.0469C13.6326 15.0469 13.7598 14.9942 13.8536 14.9004C13.9473 14.8067 14 14.6795 14 14.5469V11.5469C14 11.4143 13.9473 11.2871 13.8536 11.1933C13.7598 11.0996 13.6326 11.0469 13.5 11.0469ZM13.14 8.04688H10.86L10.6935 8.54688H13.3065L13.14 8.04688Z",
    fill: "#8C8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/RemoveIcon.67363dd2264728b98fa1159c3ef20591.svg";
export { ForwardRef as ReactComponent };